"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAutoAck = void 0;
const react_1 = require("react");
const context_1 = require("../context");
const useAutoAck = () => {
    const { selectedOrgUser } = (0, react_1.useContext)(context_1.OrganizationContext);
    const [events, setEvents] = (0, react_1.useState)([]);
    const [rules, setRules] = (0, react_1.useState)([]);
    const [isLoading, setIsLoading] = (0, react_1.useState)(true);
    const [isSaving, setIsSaving] = (0, react_1.useState)(false);
    const [hasLoadError, setHasLoadError] = (0, react_1.useState)(false);
    const load = (0, react_1.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        if (!selectedOrgUser)
            return;
        try {
            setIsLoading(true);
            setHasLoadError(false);
            const [loadedEvents, loadedRules] = yield Promise.all([
                selectedOrgUser.fetchAutoAckEvents(),
                selectedOrgUser.fetchAutoAckRules(),
            ]);
            setEvents(loadedEvents);
            setRules(loadedRules);
        }
        catch (_a) {
            setHasLoadError(true);
        }
        finally {
            setIsLoading(false);
        }
    }), [selectedOrgUser]);
    (0, react_1.useEffect)(() => {
        load();
    }, [load]);
    // The API replaces the whole array, so every edit is modelled as "build the
    // next array and PUT it". The screen still works rule-by-rule. Rules the form
    // cannot represent are carried through untouched by autoAckRuleToRequest.
    const putRules = (next) => __awaiter(void 0, void 0, void 0, function* () {
        if (!selectedOrgUser)
            throw new Error("No organization selected");
        try {
            setIsSaving(true);
            setRules(yield selectedOrgUser.saveAutoAckRules(next));
        }
        finally {
            setIsSaving(false);
        }
    });
    const saveRule = (rule, ruleId) => __awaiter(void 0, void 0, void 0, function* () {
        return putRules(ruleId
            ? rules.map(existing => existing.id === ruleId ? Object.assign(Object.assign({}, existing), rule) : existing)
            : [...rules, Object.assign(Object.assign({ id: `rule-${rules.length}` }, rule), { isEditable: true })]);
    });
    const deleteRule = (ruleId) => __awaiter(void 0, void 0, void 0, function* () { return putRules(rules.filter(rule => rule.id !== ruleId)); });
    return {
        events,
        rules,
        isLoading,
        isSaving,
        hasLoadError,
        reload: load,
        saveRule,
        deleteRule,
    };
};
exports.useAutoAck = useAutoAck;
